const { ccclass, property, menu } = cc._decorator;

/**飞刀 撞击反弹  传送门*/
@ccclass
export default class level_flyknife_door extends cc.Component {

    @property({ type: cc.Collider, displayName: "联动的传送门" })
    private otherDoor: cc.Collider = null;
   

    onCollisionEnter(other:cc.Collider, self:cc.Collider){
        if(other.node.name == "nkifeNode"){
            this.otherDoor.enabled =false
            this.scheduleOnce(()=>{
                this.otherDoor.enabled =true
            },0.5)
            other.node.setPosition(this.otherDoor.node.position)
        }
    }
   
}